export const DoppeActionTypeMembershipViewerLang = {
    defaultTexts: {
        membershipBenefit: 'Membership Benefit',
        linkButtonText: 'See More',
        price: '$10 Per Month'
    }
}